import React from 'react'

import * as style from './data-slide.module.scss'

const DataTable = ({ columns, rows, variant = 'vertical' }) => {
  const getContent = (value) => {
    if (typeof value === 'object') {
      if (value?.['img']) {
        return <img src={value?.['img']} alt={value?.['text']} />
      }

      if (value?.['html']) {
        return <div dangerouslySetInnerHTML={{ __html: value?.['html'] }} />
      }

      return value['text']
    }

    return value
  }

  return (
    <table
      className={`${style.table} ${style?.[variant] ? style[variant] : ''}`}
    >
      <thead>
        <tr>
          {columns?.length > 0 &&
            columns.map((col, index) => (
              <th key={`th-${index}`}>{getContent(col)}</th>
            ))}
        </tr>
      </thead>
      <tbody>
        {rows?.length > 0 &&
          rows.map((row, indexRow) => {
            const [firstCol, ...rest] = row

            return (
              <tr key={indexRow}>
                <td className={style.columnHeader}>{firstCol}</td>
                {rest?.length > 0 &&
                  rest.map((col, index) => (
                    <td key={`tr-${indexRow}-${index}`}>{getContent(col)}</td>
                  ))}
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}
export default DataTable
